import type React from 'react';

/**
 * Abre o seletor de data ao tocar em QUALQUER ponto do campo, no celular.
 *
 * ── O defeito (05/10) ────────────────────────────────────────────────────
 *
 * Num `<input type="date">`, alguns navegadores de celular só abrem o
 * calendário quando o toque acerta o ícone pequeno da direita. Tocar no texto
 * da data não fazia nada: sem calendário e sem teclado. O campo parecia
 * travado, e o alvo que funcionava tinha uns 20px.
 *
 * `showPicker()` abre o seletor nativo do aparelho. Só pode ser chamado dentro
 * de um gesto dela — por isso mora no `onClick`, e não num efeito.
 *
 * ── Só com o dedo ────────────────────────────────────────────────────────
 *
 * No computador, clicar no campo põe o cursor em dia, mês ou ano para digitar,
 * e isso funciona. Abrir o calendário por cima a cada clique atrapalharia quem
 * digita. `pointer: coarse` mede dedo contra mouse, não a largura da tela.
 *
 * O `try` cobre os dois modos de não dar: navegador sem `showPicker` (o `?.`
 * já resolve) e navegador que recusa por não reconhecer o gesto. Nos dois o
 * campo continua como era antes.
 */
export const abrirSeletorDeData = (e: React.MouseEvent<HTMLInputElement>): void => {
  const campo = e.currentTarget;
  if (campo.disabled || campo.readOnly) return;
  if (typeof window.matchMedia !== 'function' || !window.matchMedia('(pointer: coarse)').matches) return;
  try {
    (campo as HTMLInputElement & { showPicker?: () => void }).showPicker?.();
  } catch {
    /* o campo segue funcionando do jeito nativo */
  }
};
